import { sha256 } from 'js-sha256';
import { mintRequestPowTarget } from '../configs';



export default ({
  apiUrl,
  get,
  post,
}) => {
  const sendVote = (value, signature) => {
    return post({
      url: apiUrl,
      endPoint: '/v1/vote',
      contentType: 'application/json',
      data: {
        value, signature,
      },
    });
  }

  const sendMintRequest = (value, signature) => {
    let hash = '';
    let nonce = 0;
    let done = false;
    while (!done) {
      hash = sha256(`${nonce}${signature}`);
      if (parseInt(hash.substring(0, 8), 16) < mintRequestPowTarget) {
        done = true;
      } else {
        nonce++;
      }
    }
    return post({
      url: apiUrl,
      endPoint: '/v1/mint/request',
      contentType: 'application/json',
      data: {
        value, signature, nonce,
      },
    });
  }


  return {
    sendVote,
    sendMintRequest,
  };
}
